import { ServicePointTransactionsServiceMock } from "./servicePointTransactions.types";

export const mockServicePointTransactionsService = (): ServicePointTransactionsServiceMock => ({
  fetchServicePointLastTransactionsByServicePointId: jest.fn(),
});
